/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/quotes */
export const PCF_SITE_UNITS_SUM_ERROR = {
  message: `Site units don't match total production`
} as const;

export const PCF_SITE_UNITS_SUM_ERROR_KEY = 'pcf-site-units-sum-error';

export const PCF_SITE_UNITS_SUM_SUCCESS = {
  message: 'Site units match total production.'
} as const;

export const PCF_SITE_UNITS_SUM_SUCCESS_KEY = 'pcf-site-units-sum-success';

/** @deprecated Use PCF_SITE_UNITS_SUM_ERROR */
export const PCF_SITE_UNITS_SUM_WARNING = PCF_SITE_UNITS_SUM_ERROR;

/** @deprecated Use PCF_SITE_UNITS_SUM_ERROR_KEY */
export const PCF_SITE_UNITS_SUM_WARNING_KEY = PCF_SITE_UNITS_SUM_ERROR_KEY;
